import type {LucideIcon} from "lucide-react";
import {Flame, PawPrint, Shield, Truck, Zap} from "lucide-react";

import {EmergencyContact} from "@/src/modules/properties/types";

export type ContactType = EmergencyContact["type"];

export type ContactGroup = {
  type: ContactType;
  label: string;
  icon: LucideIcon;
  isLifeSafety: boolean;
  contacts: EmergencyContact[];
};

/** Ordered life-safety → utility → tow; groups the UI omits when empty. */
const CONTACT_TYPE_ORDER: {type: ContactType; label: string; icon: LucideIcon; isLifeSafety: boolean}[] = [
  {type: "Police Department", label: "Police Department", icon: Shield, isLifeSafety: true},
  {type: "Fire Department", label: "Fire Department", icon: Flame, isLifeSafety: true},
  {type: "Animal Control", label: "Animal Control", icon: PawPrint, isLifeSafety: true},
  {type: "Gas Company", label: "Gas Company", icon: Flame, isLifeSafety: false},
  {type: "Electricity Company", label: "Electricity Company", icon: Zap, isLifeSafety: false},
  {type: "Tow Company", label: "Tow Company", icon: Truck, isLifeSafety: false},
];

/** Groups all contacts by `type`, ordered life-safety first; omits empty groups. */
export function groupContactsByType(contacts: EmergencyContact[]): ContactGroup[] {
  return CONTACT_TYPE_ORDER.map(({type, label, icon, isLifeSafety}) => ({
    type,
    label,
    icon,
    isLifeSafety,
    contacts: contacts.filter((contact) => contact.type === type),
  })).filter((group) => group.contacts.length > 0);
}
